import { GetUserResponseDtoFeatureFlagsValue } from '@issuemanager/api-client';
import { useUserContext } from '@issuemanager/apps/client/contexts';

export function useFeatureFlags():
  | Record<string, GetUserResponseDtoFeatureFlagsValue>
  | undefined {
  const { data: userData } = useUserContext();
  return userData?.featureFlags;
}
